/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './disableInviteCodes.defs.js'
export * as $defs from './disableInviteCodes.defs.js'
